module.exports = "https://bin.bnbstatic.com/_next/static/images/currency-641ecff55dd32bc39dc5a62215a9b89f.png";